import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { Project } from '@brg/api';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { ItemType } from 'shared/constants/itemType';
import { ComputedProject } from 'shared/helpers/types/computed/ComputedProject';
import { OtherProjectsCardMeta } from './OtherProjectsCardMeta';
import {
  getProjectCoverViewType,
  isWideCoverViewType,
} from './otherProjectsMetaPlan';

const getGridColumnSpan = (project: Project, tile: ComputedProject): number => {
  const viewType = getProjectCoverViewType(
    project,
    tile?.projectType || (project as { projectType?: string })?.projectType,
  );
  return isWideCoverViewType(viewType) ? 2 : 1;
};

const Cell = styled.div<{ $span: number }>`
  grid-column: span ${({ $span }) => $span};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const OtherProjectsCardCell: FC<{
  project: Project;
  tile: ComputedProject;
  language: string;
}> = ({ project, tile, language }) => {
  const gridSpan = useMemo(() => getGridColumnSpan(project, tile), [project, tile]);

  const coverViewType = useMemo(
    () =>
      getProjectCoverViewType(
        project,
        tile?.projectType || (project as { projectType?: string })?.projectType,
      ),
    [project, tile],
  );

  return (
    <Cell $span={gridSpan}>
      <ProjectCardNew
        project={tile as any}
        itemType={ItemType.other}
        hideBelowCoverTitleAndAuthor
        {...tile}
      />
      <OtherProjectsCardMeta
        project={project}
        language={language}
        viewType={coverViewType}
      />
    </Cell>
  );
};
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { Project } from '@brg/api';
import ProjectCardNew from 'shared/components/projectCard/projectCardNew';
import { ItemType } from 'shared/constants/itemType';
import { ComputedProject } from 'shared/helpers/types/computed/ComputedProject';
import { OtherProjectsCardMeta } from './OtherProjectsCardMeta';
import {
  getProjectCoverViewType,
  isWideCoverViewType,
} from './otherProjectsMetaPlan';

const getGridColumnSpan = (project: Project, tile: ComputedProject): number => {
  const viewType = getProjectCoverViewType(
    project,
    tile?.projectType || (project as { projectType?: string })?.projectType,
  );
  return isWideCoverViewType(viewType) ? 2 : 1;
};

const Cell = styled.div<{ $span: number }>`
  grid-column: span ${({ $span }) => $span};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const OtherProjectsCardCell: FC<{
  project: Project;
  tile: ComputedProject;
  language: string;
}> = ({ project, tile, language }) => {
  const gridSpan = useMemo(() => getGridColumnSpan(project, tile), [project, tile]);

  const coverViewType = useMemo(
    () =>
      getProjectCoverViewType(
        project,
        tile?.projectType || (project as { projectType?: string })?.projectType,
      ),
    [project, tile],
  );

  return (
    <Cell $span={gridSpan}>
      <ProjectCardNew
        project={tile as any}
        itemType={ItemType.other}
        hideBelowCoverTitleAndAuthor
        {...tile}
      />
      <OtherProjectsCardMeta
        project={project}
        language={language}
        viewType={coverViewType}
      />
    </Cell>
  );
};
